import script from "./ParentStoryTitle.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ParentStoryTitle.vue?vue&type=script&lang=js"
export * from "./ParentStoryTitle.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ParentStoryTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/story-page/ParentStoryTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a29008e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a29008e', __exports__)) {
    api.reload('1a29008e', __exports__)
  }
  
}


export default __exports__